// const MessageData = (clientData, branchData) => {
//   let text;
//   const membership = clientData?.membershipDetails;

//   if (membership?.membershipType === 'serviceType') {
//     text = `Hi%20${clientData?.clientName},%20Thank%20you%20for%20choosing%20${
//       branchData?.branchName
//     }.%0A%0AMembership%20details%20is:%20%0A
//           validity:%20${membership?.endDate}%0A
//           Remaining%20Service%20and%20count: %0A
//           ${membership?.services
//             .map((service) => `service: ${service.serviceName}, remaining count: ${service.count}`)
//             .join('%0A')}
//           %0A%0A`;
//   } else {
//     text = `Hi%20${clientData?.clientName},%20Thank%20you%20for%20choosing%20${
//       branchData?.branchName || 'your branch'
//     }.%0A%0AMembership%20details%20is:%20%0A
//           Validity:%20${membership?.endDate}%0A
//           and%20Remaining%20Count%20is:%20${membership?.discount?.availableCount}%0A
//           Discount%20on%20Product%20:%20${membership?.discount?.discountOnProduct}%20${
//       membership?.discount?.productDiscountType
//     }%0A
//           Discount%20on%20Service%20:%20${membership?.discount?.discountOnService}%20${
//       membership?.discount?.serviceDiscountType
//     }%0A
//           Discount%20on%20Package%20:%20${membership?.discount?.discountOnPackages}%20${
//       membership?.discount?.packageDiscountType
//     }%0A
//           %0A%0A`;
//   }

//   // Adding country code (91) before clientNumber
//   const countryCode = '91';
//   const url = `https://api.whatsapp.com/send?phone=${countryCode}${clientData?.clientNumber}&text=${text}`;
//   return url;
// };

// export { MessageData };

const sanitizeMessage = (msg) => { 
  return encodeURIComponent(
    msg
      .replace(/\u00A0/g, ' ') // Replace non-breaking spaces with regular space
      .replace(/ +/g, ' ')     // Collapse multiple spaces
      .trim()
  );
};

// 🔹 Helper to format date in DD-MM-YYYY
const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

const MessageData = (clientData, branchData, type = "membership") => {
  const countryCode = "91";
  const branchName = branchData?.branchName || "our salon";

  let text = `Hi ${clientData?.clientName}, Thank you for choosing ${branchName}.\n\n`;

  if (type === "membership" && Array.isArray(clientData?.membershipDetails)) {
    if (clientData.membershipDetails.length === 0) {
      text += `You have no active membership at the moment.\n\n`;
    } else {
      clientData.membershipDetails.forEach((membership) => {
        const isService = membership.membershipType === "serviceType";
        const isDiscount = membership.membershipType === "discountType";

        // 🔹 Membership Name
        text += `Membership Name : ${membership?.membershipId?.membershipName || "Unnamed Membership"}\n`;

        // 🔹 Membership Type below Name
        text += `Type: ${isService ? "Service" : isDiscount ? "Discount" : "Other"}\n`;

        if (isService) {
          membership.services?.forEach(service => {
            // Count: 0 should show "0"
            text += `Service: ${service.serviceName}, Count: ${service.count > 0 ? service.count : "0"}\n`;
          });
        }

        if (isDiscount) {
          const discount = membership.discount || {};
          if (discount.discountOnProduct !== undefined) {
            text += `Discount on Product: ${discount.discountOnProduct}${discount.productDiscountType || "%"}\n`;
          }
          if (discount.discountOnService !== undefined) {
            text += `Discount on Service: ${discount.discountOnService}${discount.serviceDiscountType || "%"}\n`;
          }
          if (discount.discountOnPackages !== undefined) {
            text += `Discount on Package: ${discount.discountOnPackages}${discount.packageDiscountType || "%"}\n`;
          }
          text += `Min Bill Amount: ₹${discount.minBillAmount || 0}\n`;
        }

        // 🔹 Dates formatted
        text += `Validity: ${formatDate(membership.startDate)} to ${formatDate(membership.endDate)}\n\n`;
      });
    }
  }

  if (type === "package" && Array.isArray(clientData?.packageDetails)) {
    if (clientData.packageDetails.length === 0) {
      text += `You have no active packages at the moment.\n\n`;
    } else {
      clientData.packageDetails.forEach((pack, idx) => {
        text += `Package ${idx + 1} - ${pack.packageName || "Unnamed Package"}\n`;
        text += `Price: ₹${pack.price || 0}\n`;
        text += `Validity: ${formatDate(pack.startDate)} to ${formatDate(pack.validity)}\n`;

        if (Array.isArray(pack.services) && pack.services.length > 0) {
          text += `Included Services:\n`;
          pack.services.forEach(service => {
            text += `- ${service.serviceName}\n`;
          });
        } else {
          text += `All services used or no services found.\n`;
        }

        text += `\n`;
      });
    }
  }

  const url = `https://api.whatsapp.com/send?phone=${countryCode}${clientData?.clientNumber}&text=${sanitizeMessage(text)}`;
  return url;
};

export { MessageData };




